import React from 'react';
import PendingExtensionsTable from './PendingExtensionsTable';

const PendingExtensions = () => {
  return (
    <PendingExtensionsTable
    // data={data?.extensions?.filter((e) => !!e)}
    // loading={loading}
    />
  );
};

export default PendingExtensions;
